export enum IncomeScreenNames {
  INCOME = 'income',
  MAIN = 'income-nav',
}
